
  let $icons = $('#carusel');

  function loopImg(){
    let $first = $icons.find('.carusel__container-logo img:first-child');

    $first.animate({
     'marginLeft': '-='+ $first.outerWidth(true) +'px'
     }, 5000, 'linear', function () {
     $first.clone().removeAttr('style').appendTo($first.parent());
     $first.remove();
    loopImg();
   });
  }

  loopImg();



// WEBPACK FOOTER //
// ./app/blocks/carusel/carusel.js